import { Link } from 'react-router-dom';
import {
  Card,
  CardButton,
  Content,
  Heading,
  Inline,
  InlineItem,
  Secondary,
} from '@kinesis/bungle';
import { PathwaysIcon } from '@/components/pathways-icon';
import { pathwayScenariosPath } from '@/links';

// A synthetic, pinned, non-deletable entry for the *legacy* pathway
// surface — existing users keep access to their current pathways (the
// legacy simulator over the hand-loaded baselines) while the re-platform
// settles. Rendered by `PathwaysList` when the inventory has baseline data
// (`legacyPathwaysExist`); clicking it navigates to the untouched legacy
// pages (pure nav). The `LegacyGpcItem` treatment: no CardMenu / delete,
// and it is not a real `Pathway` so it never enters the search index.
const LegacyPathwaysItem = (props: LegacyPathwaysItemProps) => {
  const { inventoryId } = props;
  return (
    <Content borderRadiusSize='small'>
      <Card>
        <CardButton as={Link} to={pathwayScenariosPath(inventoryId)}>
          <Content padding='medium' paddingMode='equal'>
            <Inline space='medium'>
              <InlineItem>
                <PathwaysIcon />
              </InlineItem>
              <InlineItem ellipsify>
                <Heading as='h3' size='medium'>
                  Legacy pathways
                </Heading>
                <Secondary>Your existing pathway scenarios</Secondary>
              </InlineItem>
            </Inline>
          </Content>
        </CardButton>
      </Card>
    </Content>
  );
};

export type LegacyPathwaysItemProps = {
  inventoryId: number;
};

export { LegacyPathwaysItem };
